/* eslint-disable react/prop-types */ // TODO: add props
import { useEffect, useState, forwardRef } from 'react';
import cx from 'classnames';
import { Popover } from 'react-bootstrap';
import { LegacyButton } from 'edrolo-style-guide';
import { uniqueId } from 'lodash';
import UniqueOverlayTrigger from '../UniqueOverlayTrigger';
import style from './InfoPopover.scss';
import { useDismissable, useRect } from '../../hooks';
import { Icon, enums, utils as u } from 'edrolo-ui';

const Backdrop = ({ className, children }) => (
  <div className={cx('modal-backdrop', 'in', style.backdrop, className)}>
    {children}
  </div>
);

const Spotlight = ({ rect, padding }) => {
  const spotlightStyle = {
    top: rect.top - padding / 2,
    left: rect.left - padding / 2,
    width: rect.width + padding,
    height: rect.height + padding,
  };
  return <div className={style.spotlight} style={spotlightStyle} />;
};

const SpotlightBackdrop = ({ rect, padding = 5 }) => {
  return (
    <Backdrop className={style.spotlightBackdrop}>
      <Spotlight rect={rect} padding={padding} />
    </Backdrop>
  );
};

const InfoIcon = forwardRef(({ className, ...restProps }, ref) => (
  <span className={cx(style.infoIcon, className)} ref={ref} {...restProps}>
    <Icon
      name={enums.Icons.INFO_TIP}
      color={enums.ColorHue.GREY}
      className={u.ml2}
    />
  </span>
));

const InfoPopover = ({
  placement = 'bottom',
  spotlightUntilDismissed,
  children,
  dismissId,
  id,
  title,
  onDismiss,
  prerequisiteIds,
  className,
  onSpotlight,
}) => {
  const [shouldSpotlight, dismiss] = useDismissable(dismissId, prerequisiteIds);
  const [ref, rect] = useRect();
  const spotlight = spotlightUntilDismissed && shouldSpotlight;
  const [showSpotlight, setShow] = useState(spotlight);

  useEffect(() => {
    if (spotlight && ref.current) {
      onSpotlight();
      setTimeout(() => {
        setShow(true);
        window.scrollTo({
          behavior: 'smooth',
          top: ref.current.offsetTop - window.innerHeight / 2,
        });
      }, 1000);
    }
    if (!spotlight) {
      setShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [spotlight, ref]);

  const handleDismiss = () => {
    dismiss();
    onDismiss();
  };

  return (
    <>
      {showSpotlight && rect ? <SpotlightBackdrop rect={rect} /> : null}
      <UniqueOverlayTrigger
        trigger="click"
        placement={placement}
        forceInitialShow={showSpotlight}
        renderOverlay={({ hide }) => (
          <Popover id={uniqueId()} className={cx(style.popover)} title={title}>
            {children}
            {spotlight ? (
              <LegacyButton size="small" onClick={hide}>
                Continue
              </LegacyButton>
            ) : null}
          </Popover>
        )}
        uniqueOverlayId={id}
        rootClose={!spotlight}
        onHide={spotlight ? handleDismiss : undefined}
        ref={ref}
      >
        <InfoIcon className={className} />
      </UniqueOverlayTrigger>
    </>
  );
};

InfoPopover.InfoIcon = InfoIcon;

InfoPopover.defaultProps = {
  onDismiss: () => null,
  onSpotlight: () => null,
};

export default InfoPopover;
